export { default as ParagraphTitle } from './ParagraphTitle'
